<section class="dictamen-medico container py-4">
  <h2>Registro de Dictamen Médico</h2>

  <form [formGroup]="form" (ngSubmit)="onSubmit()">
    <div class="row g-3">
      <div class="col-md-3">
        <label class="form-label">Fecha</label>
        <input type="date" class="form-control" formControlName="fecha">
      </div>

      <div class="col-md-6">
        <label class="form-label">Médico Contralor</label>
        <input type="text" class="form-control" formControlName="medico" placeholder="Nombre del médico">
      </div>

      <div class="col-md-3">
        <label class="form-label">Decisión</label>
        <select class="form-control" formControlName="decision">
          <option value="recuperable">Recuperable</option>
          <option value="irrecuperable">Irrecuperable</option>
        </select>
      </div>

      <div class="col-12">
        <label class="form-label">Criterios utilizados</label>
        <textarea class="form-control" rows="5" formControlName="criterios" placeholder="Describa los criterios que llevaron a la decisión"></textarea>
      </div>

      <div class="col-12">
        <label class="form-label">Recomendaciones a la comisión médica</label>
        <textarea class="form-control" rows="5" formControlName="recomendaciones" placeholder="Recomendaciones a la comisión médica"></textarea>
      </div>

      <div class="col-12">
        <div class="d-flex gap-2 mt-3">
          <button class="btn btn-primary mr-2" type="submit">Guardar dictamen</button>
          <button class="btn btn-outline-secondary" type="button" (click)="onReset()">Limpiar</button>
        </div>
      </div>
    </div>
  </form>
</section>
